
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router';
import UserDropdownButton from '../../../components/buttons/UserDropdownButton';
import GoToIcon from '../IconNavList/industry/construction/GoToIcon';
import NavIcon from '../IconNavList/industry/construction/NavIcon';
import NotificationIcon from '../IconNavList/industry/construction/NotificationIcon';
import SwitchProjectsIcon from '../IconNavList/industry/construction/SwitchProjectsIcon';
import SearchIcon from '../IconNavList/industry/construction/SearchIcon';
import faSearch from '@fortawesome/fontawesome-pro-light/faSearch';

import 'rc-tooltip/assets/bootstrap.css';
import './NavBarNew.css';
import SightLogo from './sight.svg';

@withRouter
class NavBarNew extends React.Component {
  static propTypes = {
    user: PropTypes.instanceOf(Map),
    dispatch: PropTypes.func,
  };

  render() {
    const { dispatch, currentUser, router } = this.props;
    const path = router.location.pathname.split('/');
    const searchIcon =
      path.length === 2 && ['organizations'].includes(path[1]) ? (
        <NavIcon title={'Search'} key={'Search'} icon={faSearch}>
          <SearchIcon type={path[1]} />
        </NavIcon>
      ) : null;

    return (
      <div className="navbar-new-fixed">
        <div>
          <div className="fa-style">
            <img src={SightLogo} alt="Sight Logo" style={{ height: 37 }} />
          </div>
          {searchIcon}
        </div>
        <div>
          <div>
            <NavIcon title={'Switch Projects'} key={'Switch Projects'}>
              <SwitchProjectsIcon />
            </NavIcon>
            <NavIcon title={'Go To'} key={'Go To'}>
              <GoToIcon />
            </NavIcon>
            <NavIcon title={'Notifications'} key={'Notifications'}>
              <NotificationIcon />
            </NavIcon>
            <UserDropdownButton
              dispatch={dispatch}
              user={currentUser}
              style={{ paddingTop: 10 }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default NavBarNew;



// WEBPACK FOOTER //
// ./src/components/toolbars/NavBarNew/NavBarNew.js